import { createSelector } from 'reselect';

import { IProceduresState } from 'types/procedures.types';
import { IPerson } from 'types/persons.types';

const getItems = (state: { procedures: IProceduresState }) => state.procedures.items;
const getSelectedItem = (state: { procedures: IProceduresState }) => state.procedures.selectedItem;
const getStates = (state: { procedures: IProceduresState }) => state.procedures.states;
const getCivilStates = (state: { procedures: IProceduresState }) => state.procedures.civilStates;
const getDocumentTypes = (state: { procedures: IProceduresState }) =>
  state.procedures.documentTypes;
const getPersonStates = (state: { procedures: IProceduresState }) => state.procedures.personStates;
const getTribes = (state: { procedures: IProceduresState }) => state.procedures.tribes;

export const proceduresSelector = createSelector([getItems], (procedures) => procedures);

export const proceduresFormSelector = createSelector([getSelectedItem], (procedure) => ({
  name: procedure?.name || '',
  state: procedure?.state || '',
}));

export const proceduresStatesSelector = createSelector([getStates], (states) =>
  Object.keys(states).map((key) => ({
    label: states[key],
    value: key,
  })),
);

export const proceduresCivilStatesSelector = createSelector([getCivilStates], (civilStates) =>
  Object.keys(civilStates).map((key) => ({
    label: civilStates[key],
    value: key,
  })),
);

export const proceduresDocumentTypesSelector = createSelector([getDocumentTypes], (documentTypes) =>
  documentTypes.map((documentType) => ({
    label: documentType.name,
    value: documentType.id.toString(),
  })),
);

export const proceduresPersonStatesSelector = createSelector([getPersonStates], (personStates) =>
  Object.keys(personStates).map((key) => ({
    label: personStates[key],
    value: key,
  })),
);

export const proceduresTribesSelector = createSelector([getTribes], (tribes) =>
  Object.keys(tribes).map((key) => ({
    label: tribes[key],
    value: key,
  })),
);

export const proceduresFilesSelector = createSelector(
  [getSelectedItem],
  (procedure) =>
    procedure?.files?.map((file) => ({
      data: file.id.toString(),
      label: file.name,
      value: file.file,
    })) || [],
);

export const proceduresShowSelector = createSelector(
  [getSelectedItem],
  (procedure) =>
    procedure && {
      ...procedure,
      ...(procedure.person && {
        person: {
          ...procedure?.person,
          siblings: procedure.person?.parents
            ?.reduce((a: Array<IPerson>, b: IPerson) => [...a, ...(b?.childs ?? [])], [])
            .filter(({ id }) => procedure.person && id !== procedure.person.id),
          grandParents: procedure.person?.parents?.reduce(
            (a: Array<IPerson>, b: IPerson) => [...a, ...(b?.parents ?? [])],
            [],
          ),
        },
      }),
    },
);
